// gift.component.ts
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { page }  from '../class/status';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


interface ApiResponse {
    status: boolean;
    message: string;
    data: any[];
    active_data: any[];
    total_count: number;
}

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.css']
})


export class VideoComponent implements OnInit {

    loading: boolean = true;
    time :any={};
    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    data:any = [];
    tcontent = [
        { title: '通話對象', content: 'to_user_uid',type:3 },
        { title: '通話方向', content: 'from_user_uid',type:3 },
        { title: '通話類型', content: 'type',type:3 },
        { title: '開始時間', content: 'start_time' },
        { title: '結束時間', content: 'end_time' },
        { title: '通話秒數', content: 'secs',type:3 },
        { title: '掛斷者', content: 'break_status',type:3 },
        { title: '錄音檔', content: 'record_url',type:3 },
        { title: '審核狀態', content: 'review_status',type:3 },
    ];

    keyword = '';
    filterType = '';
    filterStatus = '';
    defaultAvatar = 'assets/avatar-default.png';
    playingUrl: string | null = null;
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    active_option_list: any = [];
    activeType = '-2';
    list_type = '-2';
    voiceType = '-2';
    active_list_type:any = [
        {id:'-2',name:'全部'},
        {id:'0',name:'未審核'},
        {id:'1',name:'符合'},
        {id:'-1',name:'不符合'},
    ];
    link:string = environment.link;


    constructor(
        public httpClient: HttpClient,
    ) {}

    ngOnInit(): void {
        this.init_list();
    }

    setReviewStatus(row: any, status: number) {

        Swal.fire({
            text: "確定要修改審核狀態嗎?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {
                const body = {id: row.id, status: status,active_id:row.active_id};
                this.httpClient.post<any>("/video/set_review_status.php", body).subscribe(res => {
                    if (res.status) {
                        this.init_list();
                        Swal.fire({
                            title: "修改成功!",
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "修改失敗!",
                            icon: "error"
                        });
                    }
                });
            }
        });
    }

    isRecordExpired(row: any): boolean {
        if (!row?.create_dt) return true;

        const createTime = new Date(row.create_dt).getTime();
        const now = Date.now();

        const diffDays = (now - createTime) / (1000 * 60 * 60 * 24);

        return diffDays > 7;
    }

    handleRangeSelected(value: any): void {
        //頁籤先歸0
        this.pageobj.page = 0;

        let eventDate = value.event;
        // 預設為空字符串
        this.time.startDate = '';
        this.time.endDate = '';

        if (eventDate && eventDate.startDate) {
          // 如果有選擇日期，使用選擇的日期
          this.time.startDate = moment(eventDate.startDate).format('YYYY-MM-DD');
          this.time.endDate = moment(eventDate.endDate).format('YYYY-MM-DD');
        } else {
          // 預設為昨天的日期
          const yesterday = moment().subtract(1, 'days');
          this.time.startDate = yesterday.format('YYYY-MM-DD');
          this.time.endDate = yesterday.format('YYYY-MM-DD');
        }
        this.init_list();
    }

    init_list() {
        this.loading = true;
        const body = {time:this.time,activeType:this.activeType,list_type:this.list_type,page: this.pageobj.page,count: this.pageobj.count,voiceType:this.voiceType,keyword:this.keyword};
        this.httpClient.post<ApiResponse>("/video/get_video_list.php", body).subscribe(res => {
            this.loading = false;
            if (res.status) {
                this.data = res.data;
                this.active_option_list = res.active_data;
                this.pageobj.total_count = res.total_count;
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
            } else {
                console.error('API Error:', res.message);
            }
        }, error => {
            this.loading = false;
            console.error('HTTP Error:', error);
        });
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    formatSecs(secs: number) {
        const s = Number(secs) || 0;
        const m = Math.floor(s / 60);
        const r = s % 60;
        return m > 0 ? `${m}分${r}秒` : `${r}秒`;
    }

    applyFilters() {
        this.pageobj.page = 0;
        this.init_list();
    }

    openRecord(recordUrl: string) {
        if (!recordUrl) return;
        const url = recordUrl.startsWith('http')? recordUrl: `https://f.talkmate.tw/${recordUrl}`;
        window.open(url, '_blank');
    }

}
